<div class="settings">
  <dt-select-line>
    <dt-select [(selectedOptions)]="graphMode">
      <dt-select-label i18n>Darstellung</dt-select-label>
      <dt-select-option [value]="'lines'" i18n>Linien</dt-select-option>
      <dt-select-option [value]="'bars'" i18n>Balken</dt-select-option>
    </dt-select>

    <dt-select [(selectedOptions)]="shownMembers" [multiple]="true">
      <dt-select-label i18n>Mitglieder</dt-select-label>
      @for (member of team.members; track member; let memberIndex = $index) { @if (graphData.members[memberIndex].valid) {
      <dt-select-option [value]="memberIndex"><dt-team-member-name [member]="member"></dt-team-member-name></dt-select-option>
      } }
    </dt-select>

    <dt-select [(selectedOptions)]="showAverage">
      <dt-select-label i18n>Mittelwert anzeigen</dt-select-label>
      <dt-select-option [value]="'none'" i18n>Keiner</dt-select-option>
      <dt-select-option [value]="'weighted'" i18n>Gewichtet</dt-select-option>
      <dt-select-option [value]="'unweighted'" i18n>Ungewichtet</dt-select-option>
      <dt-select-option [value]="'both'" i18n>Beide</dt-select-option>
    </dt-select>
  </dt-select-line>
</div>

<div>
  <div class="members">
    @for (member of team.members; track member; let memberIndex = $index) { @if (shownMembers.includes(memberIndex) &&
    graphData.members[memberIndex].valid) {
    <div class="member" (mouseenter)="hoveringLine = memberIndex" (mouseleave)="hoveringLine = -1">
      <dt-team-member-name [member]="member"></dt-team-member-name>
    </div>
    } } @if (showAverage === 'both' || showAverage === 'weighted') {
    <div class="member aggregate" (mouseenter)="hoveringLine = 'weighted'" (mouseleave)="hoveringLine = -1" i18n
      >Gewichteter Mittelwert</div
    >
    } @if (showAverage === 'both' || showAverage === 'unweighted') {
    <div class="member aggregate unweighted" (mouseenter)="hoveringLine = 'unweighted'" (mouseleave)="hoveringLine = -1" i18n
      >Ungewichteter Mittelwert</div
    >
    }
  </div>
  <div class="graph-holder" [style.--graph-padding.px]="graphPadding">
    <div class="graph-container">
      <div class="utility-label" i18n>Nutzen</div>
      <div class="y-scale">
        @for (v of yScale; track v) {
        <span>{{v}}</span>
        }
      </div>
      <div class="vertical-seperator"></div>
      <div class="graph-overlay grid-background vertical" [style.background-size]="gridBackground"> </div>
      @if (graphMode === 'lines') {
      <div class="graph-overlay grid-background horizontal" [style.background-size]="gridBackground"> </div>
      } @if (graphMode === 'lines') {
      <div class="graph-overlay">
        @for (member of graphData.members; track member; let i = $index; let last = $last) { @if (shownMembers.includes(i) && member.valid)
        {
        <svg
          class="graph-overlay line-overlay-container"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== i"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <path [attr.d]="member.line"></path>
        </svg>
        } } @if (showAverage === 'both' || showAverage === 'weighted') {
        <svg
          class="graph-overlay line-overlay-container average"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'weighted'"
        >
          <path [attr.d]="graphData.averages.weighted.line"></path>
        </svg>
        <svg
          class="graph-overlay line-overlay-container average second"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'weighted'"
        >
          <path [attr.d]="graphData.averages.weighted.line"></path>
        </svg>
        } @if (showAverage === 'both' || showAverage === 'unweighted') {
        <svg
          class="graph-overlay line-overlay-container average unweighted"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'unweighted'"
        >
          <path [attr.d]="graphData.averages.unweighted.line"></path>
        </svg>
        <svg
          class="graph-overlay line-overlay-container average unweighted second"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'unweighted'"
        >
          <path [attr.d]="graphData.averages.unweighted.line"></path>
        </svg>
        }
      </div>
      } @if (graphMode === 'lines') {
      <div class="graph-overlay">
        @for (member of graphData.members; track member; let projectIndex = $index) { @if (shownMembers.includes(projectIndex) &&
        member.valid) {
        <div class="graph-overlay member-dot-container">
          @for (vertex of member.vertices; track vertex) {
          <div
            [style.left.%]="vertex[0]"
            [style.top.%]="vertex[1]"
            class="member-dot"
            [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== projectIndex"
          ></div>
          }
        </div>
        } }
      </div>
      @if (hoveringLine !== -1) {
      <div class="graph-overlay">
        @if (!isNumber(hoveringLine)) { @for (vertex of graphData.averages[hoveringLine].vertices; track vertex) {
        <div [style.left.%]="vertex[0]" [style.top.%]="vertex[1]" class="member-value"
          >{{ graphPositionToOriginalValue(vertex[1]) / 100 | percent }}</div
        >
        } } @if (isNumber(hoveringLine)) { @for (vertex of graphData.members[hoveringLine].vertices; track vertex) {
        <div [style.left.%]="vertex[0]" [style.top.%]="vertex[1]" class="member-value"
          >{{ graphPositionToOriginalValue(vertex[1]) / 100 | percent }}</div
        >
        } }
      </div>
      } } @if (graphMode === 'bars') {
      <div class="graph-overlay">
        @for (alternativeName of alternativeNames; track alternativeName; let alternativeIndex = $index) {
        <div [style.left.%]=" (alternativeIndex) / (alternativeNames.length -1) * 100" class="bar-container">
          @for (member of graphData.members; track member; let memberIndex = $index; let last = $last) { @if
          (shownMembers.includes(memberIndex) && member.valid) {
          <div
            [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== memberIndex"
            class="bar"
            [style.height.%]="100-member.vertices[alternativeIndex][1]"
          >
            @if (hoveringLine === memberIndex) {
            <div class="member-value">{{ graphPositionToOriginalValue(member.vertices[alternativeIndex][1]) | number: '1.0-0' }}</div>
            }
          </div>
          } } @if (showAverage === 'both' || showAverage === 'weighted') {
          <div
            [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'weighted'"
            class="average"
            [style.top.%]="graphData.averages.weighted.vertices[alternativeIndex][1]"
          >
            @if (hoveringLine === 'weighted') {
            <div class="member-value"
              >{{ graphPositionToOriginalValue(graphData.averages.weighted.vertices[alternativeIndex][1]) | number: '1.0-0' }}</div
            >
            }
          </div>
          } @if (showAverage === 'both' || showAverage === 'unweighted') {
          <div
            [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'unweighted'"
            class="average unweighted"
            [style.top.%]="graphData.averages.unweighted.vertices[alternativeIndex][1]"
          >
            @if (hoveringLine === 'unweighted') {
            <div class="member-value"
              >{{ graphPositionToOriginalValue(graphData.averages.unweighted.vertices[alternativeIndex][1]) | number: '1.0-0' }}</div
            >
            }
          </div>
          }
        </div>
        }
      </div>
      }

      <div class="horizontal-seperator"></div>
      <div
        class="x-label-container"
        [style.width.%]="100 + 100 / (alternativeNames.length - 1)"
        [style.transform]="'translateX(-' + 100 / alternativeNames.length / 2 + '%)'"
      >
        @for (alternativeName of alternativeNames; track alternativeName; let alternativeIndex = $index) {
        <div
          class="x-label"
          [style.grid-column]="4 + alternativeIndex"
          [style.min-width.px]="graphMode === 'bars' ? (team.members.length + 1) * 25 : undefined"
          [matTooltip]="alternativeName"
          #tooltip="matTooltip"
          [dtOverflow]
          [dtOverflowTooltip]="tooltip"
        >
          {{ alternativeName }}
        </div>
        }
      </div>
    </div>
  </div>
</div>
